export default __webpack_public_path__ + "static/DSC_0106-3428540c32d8111a94d40fcfc589d81a.jpg";